import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e41592e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-content" }
const _hoisted_2 = { class: "option-group" }
const _hoisted_3 = { class: "option-label" }
const _hoisted_4 = { class: "option-row" }
const _hoisted_5 = { class: "option-group" }
const _hoisted_6 = { class: "option-label" }
const _hoisted_7 = { class: "option-row" }
const _hoisted_8 = { class: "option-tip" }
const _hoisted_9 = { class: "option-tip" }
const _hoisted_10 = { class: "option-tip" }

import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import type { SecuritySubSettings, UsbGuardSettings } from '@/views/dashboard/_components/group-policy-settings/group-policy-settings.service'
import { UsbProtectMode } from './usb-guard.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'usb-guard',
  props: {
  modelValue: {
    type: Object as PropType<SecuritySubSettings>,
    required: true
  },
  readonly: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props

const emits = __emit

const usbSettings = computed({
  get: () => props.modelValue.usb || {} as UsbGuardSettings,
  set: (val) => {
    const newValue = { ...props.modelValue, usb: val }
    emits('update:modelValue', newValue)
  }
})

function handleChange() {
  emits('change')
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('groupPolicySettings.usbVirusOnInsertTitle')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_radio_group, {
          modelValue: usbSettings.value.scan_auto,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((usbSettings.value.scan_auto) = $event)),
          disabled: __props.readonly,
          onChange: handleChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio, {
              class: "option-row",
              label: 0
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.usbManual')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio, {
              class: "option-row",
              label: 1
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.usbAuto')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        _createVNode(_component_el_checkbox, {
          class: "option-row",
          modelValue: usbSettings.value.scan_hidepath,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((usbSettings.value.scan_hidepath) = $event)),
          modelModifiers: { number: true },
          "true-label": 1,
          "false-label": 0,
          disabled: __props.readonly,
          onChange: handleChange
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.usbScanHiddenMalware')), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('groupPolicySettings.usbSafeOpenModeTitle')), 1),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_radio_group, {
          modelValue: usbSettings.value.protect_mode,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((usbSettings.value.protect_mode) = $event)),
          disabled: __props.readonly,
          onChange: handleChange,
          class: "vertical-radio-group"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio, {
              class: "option-row",
              label: _unref(UsbProtectMode).normal
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.usbModePublic')), 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('groupPolicySettings.usbModePublicTip')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio, {
              class: "option-row",
              label: _unref(UsbProtectMode).printShop
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.usbModePrintShop')), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('groupPolicySettings.usbModePrintShopTip')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio, {
              class: "option-row",
              label: _unref(UsbProtectMode).silent
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.usbModeQuiet')), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('groupPolicySettings.usbModeQuietTip')), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"])
      ]),
      _createVNode(_component_el_checkbox, {
        class: "option-row",
        modelValue: usbSettings.value.forbid_autorun,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((usbSettings.value.forbid_autorun) = $event)),
        modelModifiers: { number: true },
        "true-label": 1,
        "false-label": 0,
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.usbDisableAutoplay')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]),
      _createVNode(_component_el_checkbox, {
        class: "option-row",
        modelValue: usbSettings.value.create_trayicon,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((usbSettings.value.create_trayicon) = $event)),
        modelModifiers: { number: true },
        "true-label": 1,
        "false-label": 0,
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.usbLightningEject')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]),
      _createVNode(_component_el_checkbox, {
        class: "option-row",
        modelValue: usbSettings.value.show_suspendedwindow,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((usbSettings.value.show_suspendedwindow) = $event)),
        modelModifiers: { number: true },
        "true-label": 1,
        "false-label": 0,
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.usbQuickManage')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ])
  ]))
}
}

})